import { useTranslation } from 'react-i18next';

/**
 * Hero panel for auth pages
 * Displays inspirational imagery and messaging aligned with family heritage theme
 */
export function AuthHeroPanel() {
  const { t } = useTranslation('auth');

  return (
    <div className="hidden lg:block relative overflow-hidden bg-primary/5 min-h-[500px] lg:min-h-[600px]">
      {/* Background Image with Overlay */}
      <div
        className="absolute inset-0 opacity-20 mix-blend-multiply"
        style={{
          backgroundImage: "url('/images/auth_image.svg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
        aria-hidden="true"
      />

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-primary/80 to-transparent" aria-hidden="true" />

      {/* Content */}
      <div className="relative h-full flex flex-col justify-end p-8 lg:p-10 xl:p-12 text-white">
        <h1 className="text-3xl lg:text-4xl xl:text-5xl font-black leading-tight tracking-tight mb-3 lg:mb-4 text-white">
          {t('login.heroTitle', 'Discover your story.')}
        </h1>
        <p className="text-base lg:text-lg xl:text-xl font-normal text-white/90 max-w-md">
          {t('login.heroSubtitle', 'Join thousands of families tracing their heritage back through generations. Every branch tells a story.')}
        </p>
      </div>
    </div>
  );
}
